<app-modal-base [title]="title" (onSubmitEvent)="onSubmit()" [loading]="isLoading" [isDisabled]="form.invalid">
  <ng-container main *ngTemplateOutlet="content"></ng-container>
</app-modal-base>

<ng-template #content>
  <div mat-dialog-content>
    <form [formGroup]="form">
      @if (type === PropertyBookletCertificationType.energy) {
      <div class="form-group row">
        <app-input class="col-md-6" label="Identifiant du logement" [formControl]="form_propertyTaxId"></app-input>
        <app-input class="col-md-6" label="Numéro de DPE" [formControl]="form_energyDiagnosticId"></app-input>
      </div>

      <div class="form-group row">
          <app-select class="col-md-6" label="Consommation éléctrique" [formControl]="form_energyConsumptionClassification" [list]="energyClassificationList"
            [isEnum]="true" [enumName]="'EnergyClassification'" [isMultiple]="false"></app-select>
          <app-select class="col-md-6" label="Consommation gaz" [formControl]="form_greenhouseGasClassification" [list]="energyClassificationList"
            [isEnum]="true" [enumName]="'EnergyClassification'" [isMultiple]="false"></app-select>
      </div>

      <div class="form-group row">
        <app-input class="col-md-6" type="date" label="Date du DPE" [formControl]="form_energyDiagnosticDate"></app-input>
        <app-input class="col-md-6" type="date" label="Date de l'audit" [formControl]="form_energyAuditDate"></app-input>
      </div>

      <div class="form-group row">
          <app-doc-add-widget class="col-md-6"  [prop]="data.prop" category="ENERGY" title="Document DPE"
                (docSelected)="onEnergyDiagnosticDocumentDocSelected($event)" (docDeleted)="onEnergyDiagnosticDocumentDocDeleted()"
                [withSelect]="true" [withType]="false" [document]="form_energyDiagnosticDocument.value">
              </app-doc-add-widget>
          <app-doc-add-widget class="col-md-6"  [prop]="data.prop" category="ENERGY" title="Document Audit énergétique"
                (docSelected)="onEnergyAuditDocumentDocSelected($event)" (docDeleted)="onEnergyAuditDocumentDocDeleted()"
                [withSelect]="true" [withType]="false" [document]="form_energyAuditDocument.value">
              </app-doc-add-widget>
      </div>
      }
      @if (type === PropertyBookletCertificationType.quality) {
      <div class="form-group row">
        <app-input class="col-md-12" type="date" label="Date document qualité" [formControl]="form_qualitySealDate"></app-input>
        <app-doc-add-widget class="col-md-12" [prop]="data.prop" category="ENERGY" title="Document qualité"
              (docSelected)="onQualitySealDocumentDocSelected($event)" (docDeleted)="onQualitySealDocumentDocDeleted()"
              [withSelect]="true" [withType]="false" [document]="form_qualitySealDocument.value">
            </app-doc-add-widget>
      </div>
      }
      @if (type === PropertyBookletCertificationType.re2020) {
      <div class="form-group row">
        <app-doc-add-widget class="col-md-12" [prop]="data.prop" category="ENERGY" title="RE2020"
              (docSelected)="onRe2020SealDocumentDocSelected($event)" (docDeleted)="onRe2020SealDocumentDocDeleted()"
              [withSelect]="true" [withType]="false" [document]="form_re2020SealDocument.value">
            </app-doc-add-widget>
      </div>
      }
    </form>
  </div>
</ng-template>
